<template>
    <div id="app">
		<el-container class="flex-column" style="height: 100%;">
            <el-header style="padding: 0; height: 66px; z-index: 10;">
                <div class="m-top-bar">
                    <img src="../../assets/logo.jpg" alt="" height="40">
                    <div class="fs15 bold ml10">大虞新建造</div>
                    <!-- <i :class="icon_expand" style="margin-right: 15px; font-size: 20px;" @click="expand()"></i> -->
                    <div style="flex: 1;"></div>
						<el-dropdown @command="onUserCommand">
							<div class="el-dropdown-link">
								<el-avatar  src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="0"> <i class="el-icon-edit"></i> 修改密码</el-dropdown-item>
								<el-dropdown-item divided command="1"> <i class="el-icon-refresh-right"></i> 退出登陆</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
              	  </div>
			
			
			</el-header>
			<el-container class="flex-height">
                <el-aside style="width: auto; height: 100%;">
						<el-menu background-color="#30465a"  class="el-menu-vertical-demo" style="height: 100%"  >
							<div class="m-link" v-for="(menu, i) in menus" :key="i" @click="click(menu)" >
								<el-menu-item  :index="i.toString()">
									<i class="el-icon-menu"></i>
									<span slot="title"><a style='color:#bbd2e7' :class="path == menu.path ? 'active' : ''">{{ menu.title }}</a></span>
								</el-menu-item>
							</div>		
						</el-menu>
                    <!-- <el-menu
                        default-active="home"
                        class="el-menu-vertical-demo"
                        @open="handleOpen"
                        @close="handleClose"
                        @select="handleSelect"
                        :collapse="isCollapse"
                        unique-opened
                    >
                        <div v-for="(menu, i) in menus" :key="i">
                            <el-submenu :index="menu.id.toString()" v-if="menu.children.length > 0">
                                <template slot="title">
                                    <i v-if="menu.icon != null" :class="menu.icon"></i>
                                    <span slot="title">{{ menu.title }}</span>
                                </template>
                                <el-menu-item-group>
                                    <el-menu-item :index="child.path" v-for="(child, i) in menu.children" :key="i">{{ child.title }}</el-menu-item>
                                </el-menu-item-group>
                            </el-submenu>
                            <el-menu-item :index="menu.path" v-else>
                                <i v-if="menu.icon != null" :class="menu.icon"></i>
                                <span slot="title">{{menu.title}}</span>
                            </el-menu-item>
                        </div>
                    </el-menu> -->
                </el-aside>
				<el-main class="m-main-container">
					<router-view />
					<!-- <el-tabs class="h100 flex-column" v-model="editableTabsValue" type="card" closable @tab-remove="removeTab">
						<el-tab-pane
							v-for="(item, index) in editableTabs"
							:key="item.name"
							:label="item.title"
							:name="item.name"
						>
							<iframe class="w100 h100" :src="item.frame" frameborder="0"></iframe>
						</el-tab-pane>
					</el-tabs> -->
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
export default{
    data() {
		return {
			isCollapse: false,
			icon_expand: 'el-icon-s-fold',
			aside_width: 'm-expand',
			menus: [],
			menuLoaded: false,

			editableTabsValue: "1",
			editableTabs: [],
			path: ""
		};
	},
	watch: {
        $route: {
            handler() {
                this.path = window.location.href.substring(window.location.href.lastIndexOf("/"));
            },
            immediate: true
        }
    },
    created() {
        this.getMenus();
    },
    methods: {
		async getMenus() {
			let menus = [];
			let rs = await this.$api.getMenus();
            if (rs.err == 0) {
                this.menuMap = {};
                for (let menu of rs.data) {
                    if (menu.parent == 0) {
                        menu.children = [];
                        menus.push(menu);
                    } else {
                        let p = menus.find(m => {
                            return m.id == menu.parent;
                        });
                        p.children.push(menu);
                    }

                    this.menuMap[menu.path] = menu;
                }
                this.menus = menus;
            }
			
		},
		handleOpen(key, keyPath) {
			// console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			// console.log(key, keyPath);
		},
		handleSelect(index, indexPath) {
			if (indexPath != null) {
				this.$router.push(index);
				document.title = this.menuMap[index].title;
			}
		},
		click(menu) {
			if (menu.path != this.path) {
				this.$router.push(menu.path);
				document.title = menu.title;
			}
		},
		expand() {
			this.isCollapse = !this.isCollapse;
			if (this.isCollapse) {
				this.icon_expand = 'el-icon-s-unfold';
				this.aside_width = 'm-un-expand';
			} else {
				this.icon_expand = 'el-icon-s-fold';
				this.aside_width = 'm-expand';
			}
		},
		onUserCommand(command) {
			switch(command) {
				case "0": this.routeToChangePassword(); break;
				case "1": this.logout(); break;
			}
		},
		logout() {
			this.$router.push('/login');
		},
		routeToChangePassword() {
			this.$router.push('/changepwd');
		},

		removeTab(name) {
			let i = this.editableTabs.findIndex((it)=>{
				return it.name == name;
			})
			if (i >= 0) {
				this.editableTabs.splice(i, 1);
			}
		}
	}
}
</script>

<style lang="less" scoped>
#app {
	/* font-family: Avenir, Helvetica, Arial, sans-serif; */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	height: 100vh;
	font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}

.el-menu-vertical-demo {
    width: 250px;
}

.m-un-expand {
	width: auto;
}

.m-expand {
	width: 210px;
}

.m-top-bar {
	height: 66px;
	line-height: 66px;
	padding: 0px 20px;
	// border-bottom: 1px solid #ebeef5;
	display: flex;
	align-items: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.m-main-container {
	padding-top: 5px;
    height: 100%;
}

.el-dropdown-link {
	display: flex;
	align-items: center;
}



	
.m-link {
	height: 25px;
	padding: 24px 0 5px 0;
	a {
		text-decoration: none; 
		font-size: .875rem;
		color: #999; 
		cursor: pointer;

		&.active {
			color: #333;
		}
	}
	
}
</style>